/**
 * Set up the accordions on the page -- each accordion is a text block containing multiple <details> elements
 */
export const accordions = () => {
  const accordionTextBlocks = document.querySelectorAll('.alz-accordion');
  if (!accordionTextBlocks.length) return;

  accordionTextBlocks.forEach((accordionElement) => {
    accordionElement.addEventListener(
      'toggle',
      (event) => {
        const currentAccordionItem = event.target as HTMLDetailsElement;
        if (!currentAccordionItem.open) return;

        accordionElement.querySelectorAll('details').forEach((detail) => {
          if (detail !== currentAccordionItem) detail.open = false;
        });
      },
      true, // Use capture:true because 'toggle' event does not bubble on older browsers
    );
  });
};
